export enum SupportedLanguage {
  English = 'en',
  Hindi = 'hi',
  Bengali = 'bn',
  Telugu = 'te',
  Marathi = 'mr',
  Tamil = 'ta',
  Gujarati = 'gu',
  Kannada = 'kn',
  Malayalam = 'ml',
  // Punjabi = 'pa',
  // Urdu = 'ur',
  // Assamese = 'as',
  Odia = 'or',
}

export enum SupportedReligion {
  Hinduism = 'hinduism',
  Islam = 'islam',
  Christianity = 'christianity',
  Sikhism = 'sikhism',
  Buddhism = 'buddhism',
  Jainism = 'jainism',
  Other = 'other',
}

export enum FieldType {
  TEXT_FIELD = 'TEXT_FIELD',
  DATE = 'DATE',
  SELECT = 'SELECT',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  MULTI_SELECT = 'MULTI_SELECT',
  TIME = 'TIME',
  AUTOCOMPLETE_DROPDOWN = 'AUTOCOMPLETE_DROPDOWN',
}

export enum BiodataFormSection {
  PERSONAL_DETAILS = 'PERSONAL_DETAILS',
  FAMILY_DETAILS = 'FAMILY_DETAILS',
  CONTACT_DETAILS = 'PERSONAL_DETAILS',
}

export enum AutoCompleteFieldLabel {
  CASTE = 'caste',
  GOTHRA = 'gothra',
  MOTHER_TONGUE = 'mothertongue',
  NAKSHATRA = 'nakshatra',
  EDUCATION = 'education',
  OCCUPATION = 'occupation',
  GAN = 'gan',
  NADI = 'nadi',
  MANGALIK = 'mangalik',
}

export enum CurrentTab {
  CHOOSE_TEMPLATE,
  CUSTOMISE_TEMPLATE,
}

// Mutually-exclusive header layouts a paid template can use.
export enum HeaderStyle {
  NONE = 'NONE',
  ICON_TEXT = 'ICON_TEXT',
  BIODATA_TITLE = 'BIODATA_TITLE',
}

// Which content layout a template renders with. Templates without a layoutId
// fall back to the classic single-column structure (TemplateStructure).
export enum LayoutId {
  CLASSIC = 'CLASSIC',
  TWO_COLUMN = 'TWO_COLUMN',
  // Two columns bracketed by full-width About Me (top) and Expectations (bottom) blocks.
  ARCH = 'ARCH',
}

// Selectable English font families. The value is the registered react-pdf
// family name (see Font.register in TemplateStructure). Only applied for the
// English locale; other locales always use their script-specific fonts.
export enum FontFamily {
  POPPINS = 'Poppins',
  GELASIO = 'Gelasio',
  PLAYFAIR = 'Playfair Display',
}

export enum BiodataOutputFileMimeTypes {
  PDF = 'application/pdf',
  PNG = 'image/png',
}

export enum SettingsItem {
  LANGUAGE = 'language',
  RELIGION = 'religion',
}

export enum BiodataOutputFormat {
  Image = 'Image',
  PDF = 'PDF',
}
